import React from "react";
import { default as MuiFormLabel } from "@mui/material/FormLabel";

function FormLabel(props) {
  return <MuiFormLabel {...props} />;
}

export default FormLabel;
